/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';

const useImageSize = (ref: React.RefObject<HTMLImageElement>) => {
    const [[imageWidth, imageHeight], setImageDimensions] = useState([0, 0]);

    const getRealImageDimensions = (src: string) => {
        let image: HTMLImageElement | null = new Image();

        image.onload = () => {
            // Ignore if image component is not mounted
            if (!ref.current) {
                return;
            }
            setImageDimensions([image?.width || 0, image?.height || 0]);
            image = null;
        };
        image.src = src;
    };

    const onImageLoaded = () => {
        // Unfortunately we are unable to extract the the dimensions from the image
        // which we have a ref to since it is within the DOM and therefore subject to
        // scaling issues. The properties natural(Width|Height) don't help either due
        // to how they are "corrected" on fractional DPR screens.
        //
        // See: https://discourse.wicg.io/t/getting-original-size-of-image-synchronously-naturalwidth-height-can-t-be-used-for-this-anymore/1782/7
        //
        // We must therefore load the image outside of the DOM in order to retrieve its
        // actual size.
        const src = ref.current?.currentSrc || ref.current?.src;

        if (src) {
            getRealImageDimensions(src);
        }
    };

    // We might not receive an onLoad event if the image src
    // is already loaded so do an initial check here in case
    // it's already present
    useEffect(() => {
        const isImageLoaded = Boolean(ref.current?.complete);

        if (isImageLoaded) {
            onImageLoaded();
        }
    }, []);

    return {
        imageWidth,
        imageHeight,
        imageLoadHandler: onImageLoaded
    };
};

export default useImageSize;
